import { render } from "./TournamentsDashboard.vue?vue&type=template&id=3d682fe3&scoped=true"
import script from "./TournamentsDashboard.vue?vue&type=script&lang=js"
export * from "./TournamentsDashboard.vue?vue&type=script&lang=js"

import "./TournamentsDashboard.vue?vue&type=style&index=0&id=3d682fe3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d682fe3"]])

export default __exports__